"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import { SLOW_MODE_MIN_MS, formatSlowModeInterval, getSlowModeInputParts, getSlowModeMs, type SlowModeUnit } from "@/helpers/waves/slow-mode.helpers";
import { useCallback, useRef, useState } from "react";
import WaveSettingRow from "./WaveSettingRow";
import WaveSlowModeEditorForm from "./WaveSlowModeEditorForm";
import { useWaveSettingUpdater } from "./useWaveSettingUpdater";
interface WaveSlowModeProps {
  readonly wave: ApiWave;
}
export default function WaveSlowMode(t0) {
  const $ = _c(26);
  const {
    wave
  } = t0;
  const {
    canEdit,
    mutating,
    saveChatUpdate,
    setToast
  } = useWaveSettingUpdater(wave);
  const cooldownMs = wave.chat.slow_mode_cooldown_ms ?? null;
  const isSlowModeEnabled = typeof cooldownMs === "number" && cooldownMs >= SLOW_MODE_MIN_MS;
  let t1;
  if ($[0] !== cooldownMs || $[1] !== isSlowModeEnabled) {
    t1 = isSlowModeEnabled ? `On · ${formatSlowModeInterval(cooldownMs)}` : "Off";
    $[0] = cooldownMs;
    $[1] = isSlowModeEnabled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const slowModeLabel = t1;
  let t2;
  if ($[3] !== cooldownMs) {
    t2 = getSlowModeInputParts(cooldownMs);
    $[3] = cooldownMs;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const initialParts = t2;
  const [value, setValue] = useState(String(initialParts.value));
  const [unit, setUnit] = useState(initialParts.unit);
  const inputRef = useRef(null);
  let t3;
  if ($[5] !== cooldownMs) {
    t3 = () => {
      const nextParts = getSlowModeInputParts(cooldownMs);
      setValue(String(nextParts.value));
      setUnit(nextParts.unit);
    };
    $[5] = cooldownMs;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const resetEditor = t3;
  let t4;
  if ($[7] !== saveChatUpdate || $[8] !== setToast || $[9] !== unit || $[10] !== value) {
    t4 = closeEditor => {
      const parsedValue = Number(value);
      if (!Number.isInteger(parsedValue) || parsedValue <= 0 || getSlowModeMs({
        value: parsedValue,
        unit
      }) < SLOW_MODE_MIN_MS) {
        setToast({
          type: "error",
          message: "Slow mode must be at least 1 second"
        });
        return;
      }
      saveChatUpdate(closeEditor, chat => ({
        ...chat,
        slow_mode_cooldown_ms: getSlowModeMs({
          value: parsedValue,
          unit
        })
      }));
    };
    $[7] = saveChatUpdate;
    $[8] = setToast;
    $[9] = unit;
    $[10] = value;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleSave = t4;
  let t5;
  if ($[12] !== saveChatUpdate) {
    t5 = closeEditor_0 => {
      saveChatUpdate(closeEditor_0, _temp);
    };
    $[12] = saveChatUpdate;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const handleDisable = t5;
  let t6;
  if ($[14] !== handleDisable || $[15] !== handleSave || $[16] !== isSlowModeEnabled || $[17] !== mutating || $[18] !== unit || $[19] !== value) {
    t6 = t7 => {
      const {
        closeEditor: closeEditor_1
      } = t7;
      return <WaveSlowModeEditorForm disabled={mutating} inputRef={inputRef} isSlowModeEnabled={isSlowModeEnabled} onCancel={closeEditor_1} onDisable={() => handleDisable(closeEditor_1)} onSave={() => handleSave(closeEditor_1)} onUnitChange={setUnit} onValueChange={setValue} unit={unit} value={value} />;
    };
    $[14] = handleDisable;
    $[15] = handleSave;
    $[16] = isSlowModeEnabled;
    $[17] = mutating;
    $[18] = unit;
    $[19] = value;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const renderEditor = t6;
  let t7;
  if ($[21] !== canEdit || $[22] !== renderEditor || $[23] !== resetEditor || $[24] !== slowModeLabel) {
    t7 = <WaveSettingRow canEdit={canEdit} editLabel="Edit slow mode" label="Slow mode" onOpen={resetEditor} renderEditor={renderEditor} valueLabel={slowModeLabel} />;
    $[21] = canEdit;
    $[22] = renderEditor;
    $[23] = resetEditor;
    $[24] = slowModeLabel;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
}
function _temp(chat_0) {
  const nextChat = {
    ...chat_0
  };
  delete nextChat.slow_mode_cooldown_ms;
  return nextChat;
}